import settingsReducer from './settings.reducer'

export default settingsReducer

export * from './settings.reducer'
// export * from './settings.actions'
export * from './settings.hooks'
export * from './settings.selectors'
export * from './settings.types'
